module.exports = __webpack_public_path__ + "images/automatic-scouts/setting_complete_ja_1-a4e9ed2e25008816f6c8e1d163be4962.png";